export default class TopXConfigModel {
    public enabled: boolean = false;
    public clientId: string = null;
    public minFixtures: number = null;
    public maxFixtures: number = null
    public competitionsWhitelist: string[] = null;
}